import { Injectable } from '@angular/core';

import $ from 'jquery';
import * as uuid from 'uuid';
import swal from 'sweetalert2';
import { TranslateService } from '../translate/translate.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from '../../components/dialog-confirm/dialog-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  private notifyId = 'N' + uuid.v4();
  constructor(
    private dialog: MatDialog,
    private translateService: TranslateService) { }

  alert = {
    success: (message?: string) => {
      this.dialog.open(DialogConfirmComponent, {
        width: '400px',
        data: {
          icon: 'done',
          title: this.translateService.translate('Success'),
          message: message || 'Done!',
          yesTitle: this.translateService.translate('Ok'),
        }
      });
    },
    warning: (message?: string) => {
      this.dialog.open(DialogConfirmComponent, {
        width: '400px',
        data: {
          icon: 'warning',
          title: this.translateService.translate('Warning'),
          message: message || 'Something went wrong!',
          yesTitle: this.translateService.translate('Ok'),
        }
      });
    },
    error: (message?: string) => {
      this.dialog.open(DialogConfirmComponent, {
        width: '400px',
        data: {
          icon: 'error',
          title: this.translateService.translate('Error'),
          message: message || 'Something went wrong!',
          yesTitle: this.translateService.translate('Ok'),
        }
      });
    },
    image: (imageUrl: string, imageWidth: number, imageHeight: number, option: { title?: string, message?: string } = {}) => {
      swal.fire({
        title: option.title,
        html: option.message,
        imageUrl,
        imageWidth,
        imageHeight,
      });
    }
  };

  notify = {
    success: (message?: string, delay?: number) => {
      // tslint:disable-next-line: max-line-length
      const style = `border-radius: 5px; margin: 0; padding: 12px; z-index: 99999; top: 5px; right: 5px; display: none; position: fixed;color: #4F8A10; background-color: #DFF2BF`;
      // tslint:disable-next-line: max-line-length
      const html = `<div id="${this.notifyId}" style="${style}"><i class="fa fa-check"></i> ${message || this.translateService.translate('Success')}</div>`;
      this.showNotify(html, delay);
    },
    warning: (message?: string, delay?: number) => {
      // tslint:disable-next-line: max-line-length
      const style = `border-radius: 5px; margin: 0; padding: 12px; z-index: 99999; top: 5px; right: 5px; display: none; position: fixed;color: #9F6000; background-color: #FEEFB3`;
      // tslint:disable-next-line: max-line-length
      const html = `<div id="${this.notifyId}" style="${style}"><i class="fa fa-exclamation-triangle"></i> ${message || this.translateService.translate('Warning')}</div>`;
      this.showNotify(html, delay);
    },
    error: (message?: string, delay?: number) => {
      // tslint:disable-next-line: max-line-length
      const style = `border-radius: 5px; margin: 0; padding: 12px; z-index: 99999; top: 5px; right: 5px; display: none; position: fixed;color: #D8000C; background-color: #FFD2D2`;
      // tslint:disable-next-line: max-line-length
      const html = `<div id="${this.notifyId}" style="${style}"><i class="fa fa-times"></i> ${message || this.translateService.translate('Error')}</div>`;
      this.showNotify(html, delay);
    }
  };

  confirm(message: string, option: { title?: string, yesTitle?: string, noTitle?: string } = {}) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: option?.title || this.translateService.translate('Confirm'),
        message,
        yesTitle: option?.yesTitle || this.translateService.translate('Yes'),
        noTitle: option?.noTitle || this.translateService.translate('No'),
      }
    });
    return new Promise(resolve => {
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          resolve();
        }
      });
    });
  }

  confirmDelete = () => this.confirm(this.translateService.translate('Delete record(s)'));

  confirmApprove = () => this.confirm(this.translateService.translate('Approve record(s)'));

  confirmWithInput = (title: string, option: { yesTitle?: string, noTitle?: string, required?: boolean } = {}) => {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: title || this.translateService.translate('Confirm'),
        yesTitle: option?.yesTitle || this.translateService.translate('Yes'),
        noTitle: option?.noTitle || this.translateService.translate('No'),
        input: {
          maxlength: 255,
          required: option?.required
        }
      }
    });
    return new Promise(resolve => {
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result === 'ACCEPT') {
            resolve('');
          } else {
            resolve(result);
          }
        }
      });
    });
    // return new Promise(resolve => {
    //   swal.fire({
    //     title,
    //     input: 'textarea',
    //     inputPlaceholder: 'Tối đa 225 ký tự...',
    //     inputAttributes: {
    //       'aria-label': 'Tối đa 225 ký tự'
    //     },
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#adadad',
    //     confirmButtonText: option.yesTitle || this.translateService.translate('Yes'),
    //     cancelButtonText: option.noTitle || this.translateService.translate('No'),
    //     reverseButtons: true,
    //     inputValidator: (value) => {
    //       if (!value || value?.length > 255) {
    //         return 'Vui lòng nhập lý do tối đa 255 ký tự!';
    //       }
    //     },
    //     allowOutsideClick: () => false
    //   }).then((result) => {
    //     if (result.value) {
    //       resolve(result.value);
    //     }
    //   });
    // });
  }

  private showNotify(html: string, delay: number) {
    if ($(`#${this.notifyId}`).length === 0) {
      $('body').append(html);
      const element = $(`#${this.notifyId}`);
      element.slideDown(200);
      setTimeout(() => {
        $('body').children(`#${this.notifyId}`).remove();
      }, delay || 5000);
    }
  }
}
